import { useEffect, useRef, useState } from 'react'
import type { CrystalOrder, MonetizationView } from '@mezha/api'
import { vkCommerce } from '../../platform/vkCommerce'
import { platform } from '../../platform/detect'
import { LocationWindow } from '../LocationWindow'
import { PlankButton } from '../../ui'
import { useShellMode } from '../../shell/ShellContext'

export function VkPaymentTest() {
  useShellMode('window')
  const [view, setView] = useState<MonetizationView | null>(null)
  const [orders, setOrders] = useState<CrystalOrder[]>([])
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const pending = useRef<{ sku: string; id: string; orderId?: string } | null>(null)
  const refresh = async () => {
    const flow = await vkCommerce()
    const v = await flow.view()
    setView(v)
    const current = (await flow.recoverOrders()).orders.filter(o => o.test_mode)
    setOrders(current)
    if (current.some(o => o.id === pending.current?.orderId && o.status !== 'pending')) pending.current = null
  }
  useEffect(() => { if (platform() === 'vk') void refresh().catch(() => setError('Тестовая оплата недоступна. Проверьте настройки интеграции.')) }, [])
  const buy = async (sku: string) => {
    if (busy) return
    setBusy(true); setError(''); setMessage('')
    if (!pending.current || pending.current.sku !== sku) pending.current = { sku, id: crypto.randomUUID() }
    try {
      const result = await (await vkCommerce()).purchase(sku, pending.current.id, true)
      pending.current.orderId = result.order.id
      setMessage(result.dialog === 'cancelled' ? 'Тестовая покупка отменена.' : result.dialog === 'failed' ? 'VK сообщил об ошибке тестовой покупки.' : 'Проверяем серверное уведомление. При ожидании обновите заказы; повтор не откроет второе окно.')
      if (result.order.status !== 'pending' || result.dialog === 'cancelled' || result.dialog === 'failed') pending.current = null
      await refresh()
    } catch { setError('Не удалось получить результат. Обновите заказы или повторите с тем же ID.') }
    finally { setBusy(false) }
  }
  return <LocationWindow title="Тестовый платёж VK" emblem="nav.settings" idBase="vk-payment-test" bodyClassName="shell-panel">
    <section className="shell-panel__sheet parch">
      <p>Только тестовые заказы. Кристаллы не начисляются. Тестировщиков приложения назначает владелец в кабинете VK.</p>
      {platform() !== 'vk' && <p>Откройте этот экран внутри VK Mini Apps.</p>}
      {error && <p role="alert">{error}</p>}
      {message && <p role="status">{message}</p>}
      {view && (!view.test_mode || !view.payments) && <p>Тестовые покупки выключены или недоступны на этом устройстве.</p>}
      {view?.test_mode && view.payments && view.products.map(p => <div key={p.sku} className="slab">
        <p>{p.title} · {p.price_votes} голосов · тест</p>
        <PlankButton disabled={busy} onClick={() => void buy(p.sku)}>Проверить тестовую покупку</PlankButton>
      </div>)}
      <PlankButton disabled={busy || platform() !== 'vk'} onClick={() => void refresh().catch(() => setError('Не удалось обновить заказы'))}>Обновить заказы</PlankButton>
      {orders.map(o => <p key={o.id} style={{ overflowWrap: 'anywhere' }}>{o.sku}: {o.status === 'test_completed' ? 'Тестовый callback принят сервером' : o.status === 'test_refunded' ? 'Тестовый возврат принят' : 'Ожидаем уведомление VK'}<br />{o.id}</p>)}
    </section>
  </LocationWindow>
}
